<div class="header">
  <h3>{{ 'Users' | translate }}</h3>
  <div
    (click)="showKeyModal()"
    tabindex="0"
    (keydown.enter)="showKeyModal()"
    class="button button-green"
  >
    <span class="material-symbols-outlined">&#xe7fe;</span>
    {{ 'user.add.addbtn' | translate }}
  </div>
</div>
<app-filters></app-filters>
<app-table></app-table>
